exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2H-H4{margin-left:250px;position:relative;padding:15px;background:#fafafa;height:100%;width:calc(100% - 250px)}._1_LV-{background:#fcfafa;padding:10px;height:100%;min-height:1080px}._2HQUB{font-size:24px;margin:0 0 15px;border-bottom:1px solid #e7e7e7;padding-bottom:10px}.oqlZD{border-radius:0;width:100%;display:block;color:#484848;font-size:16px;padding-bottom:12px;border-bottom:1px solid #dce0e0}._1Y9FY{display:table}._2kew7{display:table-row}._1_IMb{display:table-cell;float:none}._2woGm{margin-bottom:6px}.B5s8w{padding:10px;border-radius:2px;border:1px solid #aaa;color:#484848}._3gPN4,.B5s8w{height:40px;font-size:14px;background-color:#fff;font-weight:400}._3gPN4{padding:10px 32px 10px 10px;border-radius:2px;margin-bottom:8px;display:block;overflow:hidden;border:1px solid #dbdbdb;color:#767676;-webkit-appearance:none;-moz-appearance:none;appearance:none}._2qnYu{position:relative;display:inline-block;vertical-align:bottom;margin-right:5px}._3EEal{overflow:hidden}._1s9rN{font-size:16px;color:#484848;margin:6px 0}._1wgx9{font-size:14px;color:#767676;margin:6px 0;line-height:1.43;font-weight:400}.MJVk-{border-color:#ff7e82;background-color:#ff7e82;color:#fff;float:right;font-size:16px}._12B31{border-color:#ff5a5f;background-color:#ff5a5f;color:#fff}._12B31:active,._12B31:active:focus,._12B31:active:hover,._12B31:focus,._12B31:hover{border-color:#ff7e82;background-color:#ff7e82;color:#fff}.DvARk{border-color:#ff5a5f;color:#ff5a5f;background-color:#fff}.DvARk:active,.DvARk:active:focus,.DvARk:active:hover,.DvARk:focus,.DvARk:hover{border-color:#ff7e82;color:#ff7e82;background-color:#fff}._2hQCm{padding:0}.dXxdg{margin:0}a,a:hover{cursor:pointer}.s9HMC{padding-top:10px;padding-right:10px}", ""]);

// exports
exports.locals = {
	"pagecontentWrapper": "_2H-H4",
	"contentBox": "_1_LV-",
	"headerTitle": "_2HQUB",
	"panelHeader": "oqlZD",
	"table": "_1Y9FY",
	"tableRow": "_2kew7",
	"tableCell": "_1_IMb",
	"formGroup": "_2woGm",
	"formControlInput": "B5s8w",
	"formControlSelect": "_3gPN4",
	"select": "_2qnYu",
	"formSection": "_3EEal",
	"captionText": "_1s9rN",
	"labelText": "_1wgx9",
	"btn": "MJVk-",
	"btnPrimary": "_12B31",
	"btnPrimaryBorder": "DvARk",
	"noPadding": "_2hQCm",
	"noMargin": "dXxdg",
	"exportLink": "s9HMC"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/siteadmin/ViewReceipt/ViewReceipt.css
// module id = 2609
// module chunks = 15